import LoginConnectionCallback from './login-connection-callback';

export default LoginConnectionCallback;
